import React from "react";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export default function CustomSnackbar({
  message,
  severity,
  autoHideDuration = 3000,
  anchorOrigin = { vertical: "top", horizontal: "center" },
}) {
  const [snackbar, setSnackbar] = React.useState({
    open: true,
    autoHideDuration,
    message,
    severity,
    anchorOrigin,
  });

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbar((prevSnackbar) => ({ ...prevSnackbar, open: false }));
  };

  return (
    <Snackbar
      anchorOrigin={snackbar.anchorOrigin}
      open={snackbar.open}
      autoHideDuration={snackbar.autoHideDuration}
      onClose={handleSnackbarClose}
    >
      <Alert onClose={handleSnackbarClose} severity={snackbar.severity}>
        {snackbar.message}
      </Alert>
    </Snackbar>
  );
}
